import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';

@Component({
	selector: 'ngx-header',
	styleUrls: ['./header.component.scss'],
	templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
	private destroy$: Subject<void> = new Subject<void>();

	public constructor(
		private sidebarService: NbSidebarService,
		private menuService: NbMenuService,
		private themeService: NbThemeService,
		private layoutService: LayoutService,
		private breakpointService: NbMediaBreakpointsService
	) {}

	ngOnInit() {}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	toggleSidebar(): boolean {
		this.sidebarService.toggle(true, 'menu-sidebar');
		this.layoutService.changeLayoutSize();

		return false;
	}

	navigateHome() {
		this.menuService.navigateHome();
		return false;
	}

	changeTheme() {
		const { currentTheme } = this.themeService;
		this.themeService.changeTheme(currentTheme === 'default' ? 'cosmic' : 'default');
	}
}
